export const SILO_FILL_LEVELS_WIDGET_NAMESPACE = 'widget.silo-fill-levels'
